import React from "react";
import styles from "./OurPartnersRuningLine.module.scss";
import { PUBLIC_IMAGE } from "../../constants";
import ItemPartnerImage from "../ItemPartnerImage/ItemPartnerImage";

const partners = [
  "woo.svg",
  "sumsu.svg",
  "Itez.svg",
  "trustpilot.svg",
  "simplex.svg",
  "bountyHash.svg",
  "prestaShop.svg",
  "productHunt.svg",
  "coinify.svg",
  "bitcoinTalk.svg",
  "slotegrator.svg",
  "praxis.svg",
  "kingServers.svg",
  "chainalysis.svg",
  "moonpay.svg",
  "slotegrato.svg",
];

export default function OurPartnersRunningLine() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>We are trusted</div>
      <div className={styles.marquee}>
        <div className={styles.track}>
          {partners.map((p) => (
            <ItemPartnerImage key={p} image={PUBLIC_IMAGE + p} />
          ))}
          {partners.map((p, i) => (
            <ItemPartnerImage key={p + "_copy"} image={PUBLIC_IMAGE + p} />
          ))}
        </div>
      </div>
    </div>
  );
}
